import {useQuery} from '@tanstack/react-query'
import {apiGetActiveLeagueList, apiGetLeagueList} from '@api/rank/league/league'
import {useRouter} from 'next/router'
import useDidMountEffect from '@hook/UseDidMountEffect'

export const useActiveLeagues = (enabled?: boolean) => {
    return useQuery({
        enabled: enabled ?? true,
        queryKey: ['active-leagues'],
        queryFn: async () => {
            const {data} = await apiGetActiveLeagueList()
            return data
        },
    })
}

export const useQueryGetAllLeagues = (enabled?: boolean) => {
    const router = useRouter()

    const {data, refetch} = useQuery({
        enabled: enabled ?? true,
        queryKey: ['all-leagues', router?.locale],
        staleTime: 60 * 1000,
        cacheTime: 60 * 1000,
        keepPreviousData: true,
        retry: true,
        retryDelay: 2000,
        queryFn: async () => {
            const {data} = await apiGetLeagueList(router?.locale)
            return data
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}
